<template>
  <ul class="button-group" :class="classObject">
    <li v-if="slots.firstButton"><slot name="firstButton"></slot></li>
    <li v-if="slots.secondButton"><slot name="secondButton"></slot></li>
  </ul>
</template>

<script setup>
const slots = useSlots()
const props = defineProps({
  /**
   * 並びの向き
   * @values col, row
   */
    direction: {
    type: String,
    default: 'col',
  },
})

const classObject = computed(() => {
  return {
    col: props.direction === 'col',
    row: props.direction === 'row',
  }
})

</script>

<style lang="scss" scoped>
.button-group {
  display: flex;

  &.row {
    justify-content: center;

    > li {
      margin: 0 1rem;
    }
  }

  &.col {
    flex-direction: column;

    > li {
      + li {
        margin-top: 1.5rem;
      }
    }
  }
}
</style>
